import { useAuthContext } from "../context/AuthContext";

function useCompanyTypeMiddleware(types) {
  const authContext = useAuthContext();

  /**
   * This method will validate the middleware
   * @returns {boolean}
   */
  function validate() {
    types = Array.isArray(types) ? types : [types];
    return types.includes(authContext.auth.user?.company.type);
  }

  /**
   * This method return the redirect instructions on fail
   * @returns {{ to: string, replace: boolean }}
   */
  function redirect() {
    return { to: "/dashboard", replace: true };
  }

  //return the middleware
  return { validate, redirect };
}

export default useCompanyTypeMiddleware;
